export default __webpack_public_path__ + "634b02e616a474305a6b762443133752.png";